import React, { createContext, useContext, useState, useEffect, ReactNode } from "react"; // v2

type Language = "en" | "ar";

type Translations = Record<string, Record<Language, string>>;

const translations: Translations = {
  "nav.home": { en: "Home", ar: "الرئيسية" },
  "nav.menu": { en: "Menu", ar: "المنيو" },
  "nav.cart": { en: "Cart", ar: "السلة" },
  "nav.profile": { en: "Profile", ar: "الملف الشخصي" },
  "nav.track": { en: "Track Order", ar: "تتبع الطلب" },
  "hero.title": { en: "Order Your Favorites, Fast", ar: "اطلب أطباقك المفضلة بسرعة" },
  "hero.subtitle": { en: "Fresh food, made your way. Dine in, take away, or get it delivered.", ar: "طعام طازج حسب ذوقك. تناول في المطعم، خذ معك، أو اطلب توصيل." },
  "hero.cta": { en: "Order Now", ar: "اطلب الآن" },
  "order.type": { en: "How would you like your order?", ar: "كيف تريد طلبك؟" },
  "order.dinein": { en: "Dine In", ar: "تناول في المطعم" },
  "order.dinein.desc": { en: "Enjoy your meal at the restaurant", ar: "استمتع بوجبتك في المطعم" },
  "order.takeaway": { en: "Takeaway", ar: "خذ معك" },
  "order.takeaway.desc": { en: "Pick up at the counter", ar: "استلم من الكاونتر" },
  "order.delivery": { en: "Delivery", ar: "توصيل" },
  "order.delivery.desc": { en: "Delivered to your door", ar: "يوصل لباب بيتك" },
  "featured.title": { en: "Popular Right Now", ar: "الأكثر طلباً الآن" },
  "promos.title": { en: "Hot Deals", ar: "عروض ساخنة" },
  "menu.search": { en: "Search menu...", ar: "ابحث في القائمة..." },
  "menu.filters": { en: "Filters", ar: "تصفية" },
  "menu.allCategories": { en: "All", ar: "الكل" },
  "menu.addToCart": { en: "Add to Cart", ar: "أضف للسلة" },
  "menu.customize": { en: "Customize", ar: "تخصيص" },
  "menu.size": { en: "Size", ar: "الحجم" },
  "menu.extras": { en: "Extras", ar: "إضافات" },
  "menu.remove": { en: "Remove", ar: "إزالة" },
  "menu.specialInstructions": { en: "Special Instructions", ar: "تعليمات خاصة" },
  "menu.quantity": { en: "Quantity", ar: "الكمية" },
  "menu.total": { en: "Total", ar: "المجموع" },
  "menu.combo.save": { en: "Save", ar: "وفّر" },
  "cart.empty": { en: "Your cart is empty", ar: "السلة فارغة" },
  "cart.empty.desc": { en: "Add some delicious items from our menu!", ar: "أضف بعض الأطباق اللذيذة من قائمتنا!" },
  "cart.items": { en: "items", ar: "عناصر" },
  "cart.title": { en: "Your Cart", ar: "سلتك" },
  "cart.orderType": { en: "Order Type", ar: "نوع الطلب" },
  "cart.change": { en: "Change", ar: "تغيير" },
  "cart.promoCode": { en: "Promo Code", ar: "رمز الخصم" },
  "cart.apply": { en: "Apply", ar: "تطبيق" },
  "cart.promoApplied": { en: "Promo applied!", ar: "تم تطبيق الخصم!" },
  "cart.promoInvalid": { en: "Invalid promo code", ar: "رمز خصم غير صالح" },
  "cart.promoExpired": { en: "Promo code has expired", ar: "انتهت صلاحية رمز الخصم" },
  "cart.promoNotStarted": { en: "Promo code is not active yet", ar: "رمز الخصم غير نشط بعد" },
  "cart.promoMaxUses": { en: "Promo code usage limit reached", ar: "تم الوصول لحد استخدام رمز الخصم" },
  "cart.promoMinOrder": { en: "Order does not meet minimum amount", ar: "الطلب لا يستوفي الحد الأدنى" },
  "cart.loyalty": { en: "Loyalty Points", ar: "نقاط الولاء" },
  "cart.loyaltyBalance": { en: "Your balance", ar: "رصيدك" },
  "cart.redeemPoints": { en: "Redeem points", ar: "استبدال النقاط" },
  "cart.deliveryAddress": { en: "Delivery Address", ar: "عنوان التوصيل" },
  "cart.deliveryTime": { en: "Estimated Delivery", ar: "وقت التوصيل المتوقع" },
  "cart.scheduleOrder": { en: "Schedule Order", ar: "جدولة الطلب" },
  "cart.pickupTime": { en: "Pickup Time", ar: "وقت الاستلام" },
  "cart.asap": { en: "ASAP", ar: "في أسرع وقت" },
  "cart.scheduleLater": { en: "Schedule for Later", ar: "الطلب لوقت لاحق" },
  "cart.asapAvailable": { en: "ASAP Delivery Available", ar: "في أسرع وقت التوصيل المتاح" },
  "cart.notes": { en: "Order Notes", ar: "ملاحظات الطلب" },
  "cart.notesPlaceholder": { en: "Any special requests or instructions...", ar: "أي طلبات أو تعليمات خاصة..." },
  "cart.selectDate": { en: "Select Date & Time", ar: "اختر التاريخ والوقت" },
  "cart.selectTime": { en: "Select Time", ar: "اختر الوقت" },
  "cart.confirm": { en: "Confirm", ar: "تأكيد" },
  "cart.scheduledFor": { en: "Scheduled for", ar: "مجدول في" },
  "cart.payment": { en: "Payment Method", ar: "طريقة الدفع" },
  "cart.payOnline": { en: "Pay Online", ar: "دفع إلكتروني" },
  "cart.payCash": { en: "Cash", ar: "نقداً" },
  "cart.subtotal": { en: "Subtotal", ar: "المجموع الفرعي" },
  "cart.discount": { en: "Discount", ar: "الخصم" },
  "cart.deliveryFee": { en: "Delivery Fee", ar: "رسوم التوصيل" },
  "cart.tax": { en: "Tax", ar: "الضريبة" },
  "cart.total": { en: "Total", ar: "الإجمالي" },
  "cart.placeOrder": { en: "Place Order", ar: "تأكيد الطلب" },
  "cart.placingOrder": { en: "Placing Order...", ar: "جاري تقديم الطلب..." },
  "cart.orderSuccess": { en: "Order placed successfully!", ar: "تم تقديم الطلب بنجاح!" },
  "cart.orderError": { en: "Failed to place order. Please try again.", ar: "فشل تقديم الطلب. يرجى المحاولة مرة أخرى." },
  "cart.clearCart": { en: "Clear Cart", ar: "تفريغ السلة" },
  "cart.browseMenu": { en: "Browse Menu", ar: "تصفح القائمة" },
  "cart.selectBranch": { en: "Select a Branch", ar: "اختر فرعاً" },
  "cart.selectBranchDesc": { en: "Please choose a branch before placing your order", ar: "يرجى اختيار فرع قبل تقديم الطلب" },
  "cart.chooseBranch": { en: "Choose Branch", ar: "اختر الفرع" },
  "cart.selectBranchFirst": { en: "Select a Branch First", ar: "اختر فرعاً أولاً" },
  "cart.free": { en: "Free", ar: "مجاناً" },
  "footer.rights": { en: "All rights reserved.", ar: "جميع الحقوق محفوظة." },
  "footer.tagline": { en: "Fresh food, bold flavors.", ar: "طعام طازج، نكهات جريئة." },
  "filter.vegan": { en: "Vegan", ar: "نباتي" },
  "filter.glutenFree": { en: "Gluten-Free", ar: "خالٍ من الغلوتين" },
  "filter.halal": { en: "Halal", ar: "حلال" },
  "filter.spicy": { en: "Spicy", ar: "حار" },
  "profile.title": { en: "My Profile", ar: "ملفي الشخصي" },
  "profile.info": { en: "Personal Info", ar: "المعلومات الشخصية" },
  "profile.editProfile": { en: "Edit Profile", ar: "تعديل الملف" },
  "profile.addresses": { en: "Saved Addresses", ar: "العناوين المحفوظة" },
  "profile.noAddresses": { en: "No saved addresses", ar: "لا توجد عناوين محفوظة" },
  "profile.loyalty": { en: "Loyalty Program", ar: "برنامج الولاء" },
  "profile.points": { en: "points", ar: "نقطة" },
  "profile.pointsToNext": { en: "points to", ar: "نقطة للوصول إلى" },
  "profile.recentEarnings": { en: "Recent Earnings", ar: "الأرباح الأخيرة" },
  "profile.orderHistory": { en: "Order History", ar: "سجل الطلبات" },
  "profile.reorder": { en: "Reorder", ar: "إعادة الطلب" },
  "nav.branches": { en: "Branches", ar: "الفروع" },
  "nav.about": { en: "About", ar: "عن المطعم" },
  "branches.title": { en: "Our Branches", ar: "فروعنا" },
  "branches.subtitle": { en: "Find a branch near you", ar: "اعثر على فرع قريب منك" },
  "branches.empty": { en: "No branches listed yet", ar: "لا توجد فروع مسجلة بعد" },
  "branches.viewMap": { en: "View on Map", ar: "عرض على الخريطة" },
  "about.story": { en: "Our Story", ar: "قصتنا" },
  "about.mission": { en: "Our Mission", ar: "مهمتنا" },
  "about.team": { en: "Our Team", ar: "فريقنا" },
  "about.contact": { en: "Contact Us", ar: "تواصل معنا" },

  // Branch modal
  "branch.howToOrder": { en: "How would you like to order?", ar: "كيف تريد أن تطلب؟" },
  "branch.pickup": { en: "Pickup", ar: "استلام" },
  "branch.pickupDesc": { en: "Pick up your order at the nearest branch", ar: "استلم طلبك من أقرب فرع" },
  "branch.pickupTime": { en: "Ready in ~15 min", ar: "جاهز خلال ~١٥ دقيقة" },
  "branch.delivery": { en: "Delivery", ar: "توصيل" },
  "branch.deliveryDesc": { en: "We deliver to your location", ar: "نوصل لموقعك" },
  "branch.deliveryTime": { en: "Delivered in ~30 min", ar: "يوصل خلال ~٣٠ دقيقة" },
  "branch.dinein": { en: "Dine In", ar: "أكل في المطعم" },
  "branch.dineinDesc": { en: "Enjoy your meal at the restaurant", ar: "استمتع بوجبتك في المطعم" },
  "branch.selectBranch": { en: "Select a Branch", ar: "اختر فرعاً" },
  "branch.searchBranches": { en: "Search branches...", ar: "ابحث عن فرع..." },
  "branch.select": { en: "Select", ar: "اختر" },
  "branch.open": { en: "Open", ar: "مفتوح" },
  "branch.closed": { en: "Closed", ar: "مغلق" },
  "branch.busy": { en: "Busy", ar: "مشغول" },
  "branch.readyIn": { en: "Ready in ~{min} min", ar: "جاهز خلال ~{min} دقيقة" },
  "branch.kmAway": { en: "{km} km away", ar: "{km} كم" },
  "branch.noBranches": { en: "No branches available in your area", ar: "لا توجد فروع متاحة في منطقتك" },
  "branch.branchBusyTitle": { en: "This branch is currently busy", ar: "هذا الفرع مشغول حالياً" },
  "branch.branchBusyDesc": { en: "Wait times may be longer than usual.", ar: "قد يستغرق الانتظار وقتاً أطول." },
  "branch.mayVary": { en: "may vary", ar: "قد يختلف" },
  "branch.chooseAnother": { en: "Choose Another", ar: "اختر فرعاً آخر" },
  "branch.continue": { en: "Continue", ar: "متابعة" },
  "branch.selectLocation": { en: "Select Delivery Location", ar: "حدد موقع التوصيل" },
  "branch.deliveryComingSoon": { en: "Delivery Coming Soon", ar: "التوصيل قريباً" },
  "branch.deliveryComingSoonDesc": { en: "Delivery ordering will be available soon. For now, please choose pickup.", ar: "طلب التوصيل سيكون متاحاً قريباً. حالياً، يرجى اختيار الاستلام." },
  "branch.choosePickup": { en: "Choose Pickup Instead", ar: "اختر الاستلام بدلاً من ذلك" },
  "branch.detectingAddress": { en: "Detecting address…", ar: "جارٍ تحديد العنوان…" },
  "branch.dragPin": { en: "Drag the pin or tap the map to set your delivery location", ar: "اسحب الدبوس أو انقر على الخريطة لتحديد موقع التوصيل" },
  "branch.deliveryNotes": { en: "Apartment, floor, or delivery notes…", ar: "شقة، طابق، أو ملاحظات التوصيل…" },
  "branch.confirmLocation": { en: "Confirm Location", ar: "تأكيد الموقع" },
  "branch.myLocation": { en: "My Location", ar: "موقعي" },
  "branch.changeWillClear": { en: "Changing your branch will clear your cart", ar: "تغيير الفرع سيفرغ سلتك" },
  "branch.itemsInCart": { en: "You have {count} items in your cart from {branch}.", ar: "لديك {count} عناصر في سلتك من {branch}." },
  "branch.switchingWillClear": { en: "Switching will start a new order.", ar: "التبديل سيبدأ طلباً جديداً." },
  "branch.keepCurrent": { en: "Keep Current", ar: "إبقاء الحالي" },
  "branch.switchClear": { en: "Switch & Clear Cart", ar: "تبديل وتفريغ السلة" },
  "branch.noBranchError": { en: "No branches available in your area. Please select a different location.", ar: "عميلنا العزيز، لا يوجد فرع متاح في منطقتك حالياً. يُرجى اختيار موقع آخر." },

};

type LanguageContextType = {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
  isRTL: boolean;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<Language>(() => {
    try { const saved = localStorage.getItem("blazebite_lang"); return saved === "en" || saved === "ar" ? saved : "ar"; } catch { return "ar"; }
  });
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    try { localStorage.setItem("blazebite_lang", lang); } catch {}
  };
  const isRTL = language === "ar";

  useEffect(() => {
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
    document.documentElement.lang = language;
  }, [language, isRTL]);

  const t = (key: string): string => {
    return translations[key]?.[language] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
}
